import { TableElementMoreMenuOpenState } from 'state_management/zustand/uiSlice';

import { PredecessorCollab } from './collab/clientTypes-workers';
import { ScheduleElementCollab } from './collab/scheduleElementTypes';
import { EMPTY_ELEMENT, Predecessor, Successor } from './scheduler/core_element_types';
import { HandleType, Plan, ScheduleElement } from './scheduler/scheduler_types';

export const PDF_SERVER_KEY = 'pdf_server';
export const CHAT_SERVER_URL_KEY = 'chat_server_url';
export const SHOW_MPP_DUMMY_RESPONSE_KEY = 'show_mpp_dummy_response';
export const SHOW_PASTE_ACTIVITY_IDS_DIALOG_KEY = 'show_paste_activity_ids_dialog';
export const PLANERA_DOMAIN = 'planera.io';
export const PENDING_ELEMENT_ID = ''; // This is causing issues during requests to the server. Should remain blank and convert to ... in UI
export const LASSO_CONTAINER_SELECTOR = '.selecto-selection';
export const LASSO_CONTAINER_ACTIVATED_CLASS = 'selecto-selection-active';
export const IMPORTED = 'imported';
export const VERSIONED = 'versioned';
export const HELP_URL = 'https://help.planera.io';

export const CANVAS_NODE_TYPES = {
  activity: 'activity',
  group: 'group',
  dynamic: 'dynamic'
};
export const CANVAS_EDGE_PATHS_KEY = 'edge-paths-types';
export const CANVAS_EDGE_PATHS = {
  smoothStep: 'smooth-step',
  bezier: 'bezier'
};

export const CANVAS_SHOW_HANDLE_TRIGGER_KEY = 'show-handle-trigger';
export const CANVAS_SHOW_HANDLE_TRIGGER = {
  hover: 'hover',
  select: 'select'
};

export enum ProjectTag {
  Status = 'Status',
  Type = 'Type'
}

export const EXPORT_STEP_DESCRIPTIONS = ['Choose What To Export', 'Choose Export Format', 'Review Export'];

// export const EMPTY_PROJECT: Project = {
//     id: '',
//     name: '',
//     description: '',
//     start: '',
//     plannedFinish: '',
//     calculatedFinish: '',
//     createdBy: '',
//     lastEditedBy: '',
//     userSettings: {},
//     timestamps: {
//         created: '',
//         updated: '',
//         deleted: ''
//     },
//     calendarId: ''
// }

// export const LOCAL_PROJECT: Project = {
//     ...EMPTY_PROJECT,
//     id: 'localproject',
//     name: "⚠️ Serverless Sandbox ⚠️"
// }

export const EMPTY_FS_PREDECESSOR_COLLAB: PredecessorCollab = {
  predGuid: '',
  sourceGuid: '',
  type: 'FS',
  lag: 0,
  lagType: ''
};

export const EMPTY_FS_PREDECESSOR: Predecessor = {
  predGuid: '',
  predId: '',
  succGuid: '',
  type: 'FS',
  lag: 0,
  lagType: ''
};

export const EMPTY_FS_SUCCESSOR: Successor = {
  succGuid: '',
  succId: '',
  type: 'FS',
  lag: 0,
  lagType: ''
};

export const EMPTY_COLLAB_ELEMENT: ScheduleElementCollab = {
  guid: '',
  id: '',
  elementType: 'empty',
  name: '',
  x: 0,
  y: 0,
  resourceWorkHours: undefined,
  durationMin: 0,
  durationMax: 0,
  durationMinUnits: 'day',
  durationMaxUnits: 'day',
  startDate: null,
  endDate: null,
  cpmData: {
    earlyStart: null,
    earlyFinish: null,
    lateStart: null,
    lateFinish: null,
    totalFloat: null,
    freeFloat: null
  },
  timestamps: {
    created: null
  },
  calendarId: ''
};

export const dELETED_ELEMENT = (elementGuid: string): ScheduleElement => {
  return { ...EMPTY_ELEMENT, predecessors: [], successors: [], children: [], guid: elementGuid, deleted: true };
};

export const HANDLE_TYPES: { PREDECESSOR: HandleType; SUCCESSOR: HandleType } = {
  PREDECESSOR: 'S',
  SUCCESSOR: 'F'
};

export enum TREE_TYPES {
  EMPTY = 'EMPTY',
  HISTORY_DIALOG = 'HISTORY_DIALOG',
  COMBO_SEARCH = 'COMBO_SEARCH',
  MULTIPLE_RELATION_COMBO_SEARCH = 'MULTIPLE_RELATION_COMBO_SEARCH',
  NAVIGATION_DIALOG = 'NAVIGATION_DIALOG',
  SEARCH_CONNECT_POPUP = 'SEARCH_CONNECT_POPUP',
  PEEK_WBS = 'PEEK_WBS',
  WATCH_IMPORTANT_DATE = 'WATCH_IMPORTANT_DATE',
  TIMESPAN_ELEMENT = 'TIMESPAN_ELEMENT',
  PROJECT_TITLE = 'PROJECT_TITLE',
  SIMULATIONS = 'SIMULATIONS',
  LOOK_AHEAD_SEARCH = 'LOOK_AHEAD_SEARCH'
}

export enum FLOATING_UI {
  DATA_PANEL = 'DATA_PANEL',
  ACTIVITY_DETAILS = 'ACTIVITY_DETAILS',
  RELATIONSHIPS = 'RELATIONSHIPS',
  CHAT = 'CHAT'
}

export const FLOATING_UI_PARAMS: { [key: string]: { id: string; minWidth: number; minHeight: number; smallerWidth: number; largerWidth: number } } = {
  DATA_PANEL: {
    id: 'floating-data-panel',
    minWidth: 907,
    minHeight: 160,
    smallerWidth: 674,
    largerWidth: 1127
  },
  ACTIVITY_DETAILS: {
    id: 'floating-activity-details',
    minWidth: 1000,
    minHeight: 196,
    smallerWidth: 1196,
    largerWidth: 1196
  },
  RELATIONSHIPS: {
    id: 'floating-relationships',
    minWidth: 1000,
    minHeight: 196,
    smallerWidth: 1196,
    largerWidth: 1196
  },
  CHAT: {
    id: 'floating-chat',
    minWidth: 400,
    minHeight: 300,
    smallerWidth: 400,
    largerWidth: 600
  }
};

export const GROUP_CONNECTION_DIRECTION = {
  LR: 'LR',
  RL: 'RL'
};

export enum EDITING_FIELD {
  NAME = 'NAME',
  DURATION = 'DURATION'
}

export const SCROLL_ELEMENT_VISIBILITY = {
  IN_VIEW: 'inView',
  ABOVE: 'above',
  BELOW: 'below'
};

export const EMPTY_RIGHT_CLICK_ELEMENT = { elementGuid: '', parentGuid: '', elementName: '', elementType: undefined, navigateTo: undefined, threadToHighlight: '' };
export const EMPTY_TABLE_ELEMENT_MORE_MENU_OPEN: TableElementMoreMenuOpenState = { virtualGuid: '', elementGuid: '', parentGuid: '', elementName: '', elementType: undefined, isVirtualElement: false, open: false, children: [], colId: '' };
export const EMPTY_TABLE_HEADER_MENU_OPEN = { columnId: '', open: false };
export const EMPTY_TABLE_MULTI_SELECTION_MENU = { rowId: '', colId: '' };

export const IMPORT_ERROR_CODES = {
  ErrCodeImportInternalGeneral: 13003,
  ErrCodeImportFileParsingError: 13004,
  ErrCodeImportNoDefaultCal: 13005,
  ErrCodeImportMissingCalId: 13006,
  ErrCodeImportMissingCalName: 13007,
  ErrCodeImportMissingWorkWeek: 13008,
  ErrCodeImportInvalidActStatus: 13009,
  ErrCodeImportInvalidConstraint: 13010,
  ErrCodeImportInvalidActType: 13011,
  ErrCodeImportMissingRelationAct: 13012
};

export const IMPORT_ERRORS: { [key: string]: string } = {
  '13003': 'Internal server error',
  '13004': 'File parsing error',
  '13005': 'No default calendar',
  '13006': 'Missing calendar ID',
  '13007': 'Missing calendar name',
  '13008': 'Missing work week',
  '13009': 'Invalid activity status',
  '13010': 'Invalid constraint',
  '13011': 'Invalid activity type',
  '13012': 'Missing relationship activity'
};

export const CPM_ERROR_CODES = {
  START_DATE_UNDEFINED: 10002,
  START_MILESTONE_UNDEFINED: 10000,
  END_MILESTONE_UNDEFINED: 10001,
  CIRCULAR_RELATIONSHIP: 10102,
  CALENDAR_UNDEFINED: 10300,
  CALENDAR_0_WORKHOURS: 10301,
  INTERNAL_CPM_ERROR: 19900,
  MISSING_PREDECESSOR: 10100,
  MISSING_SUCCESSOR: 10101,
  DURATION_INVALID: 10200,
  TASK_MISSING_PARENT: 10103,
  CPM_NOT_READY: 10400,
  BAD_ACTUALS_MODE: 10500,
  UNSUPPORTED_ACTUALS_MODE: 10501
};

export const RUN_SCHEDULE_ERRORS: { [key: string]: string } = {
  '10000': 'Project start date required to run schedule',
  '10002': 'Project start date required to run schedule',
  '10102': 'Circular relationship error. Please contact support.',
  '10103': 'Task has missing parent. Please contact support.',
  '10200': 'Duration issue. Please check for negative durations.',
  '10300': 'Calendar missing. Please assign a calendar to this project.',
  '10301': 'Calendar empty. Please add working days.',
  '10302': 'No available dates for some activities. Check calendar for details.',
  '10400': 'CPM not ready. Please try again later.',
  '10500': 'Bad actuals. Please contact support.',
  '10501': 'Unsupported actuals. Please contact support.',
  '19900': 'Internal CPM error. Please contact support.'
};

export const EMPTY_TABLE_LOCATE_USER = {
  tableSelection: { rowId: null, rowIndex: null, field: '', tab: '' },
  info: { name: '', picture: '' },
  name: '',
  connectionId: -1,
  authUserId: ''
};

export const PLANERA_USER_NAME = 'Planera User';

export const MAIN_HEADER_HEIGHT = 44;
export const WBS_LAYER_MARGIN = 7;
export const WBS_LAYER_BORDER = 2;
export const WBS_MAXIMUM_LAYERS = 3;
export const WBS_LAYER_OUTSIDE_MARGIN = 12;
export const FIRST_ANIMATED_BOX_ID = 'animatedBox1-entered';
export const EXPANDED_GROUP_CLASS_FOR_DROPPING_ELEMENTS = 'expandedGroupForDragDropAnimation';

export const TABLE_PRE_DEFINED_CUSTOM_CODES_NAMES = {
  LOCATION: 'Location',
  RESPONSIBLITY: 'Responsibility'
};

export const CUSTOM_COLUMN_ID_PRE = 'custom-code-';

export const MAX_COLOR_LEVELS = 10;
export const VERSION_NODE_COLORS = ['#7437F4', '#F53859', '#F46D37', '#0D968B', '#F43787', '#BF37F4', '#38B6F5', '#CC7A29'];
export const ORGANIZATION_CODE_COLORS = ['#afc6fd', '#aff2fe', '#94f7aa', '#fdafb9', '#fdf2af', '#d0affd', '#fdd5af', '#f7affd', '#9bf4d5', '#fdc3af'];
export const VARIANCE_REASONS_COLORS = ['#3761F4', '#38B6F5', '#95D62F', '#F43787', '#F4CB37', '#7437F4', '#F46D37', '#BF37F4', '#0D968B'];

export const VARIANCE_REASONS_COLORS_TABLE_MAP: { [key: string]: string } = { '#3761F4': '#afc6fd', '#38B6F5': '#aff2fe', '#95D62F': '#e5faac', '#F43787': '#fdafb9', '#F4CB37': '#fdf2af', '#7437F4': '#d0affd', '#F46D37': '#fdd5af', '#BF37F4': '#f7affd', '#0D968B': '#9bf4d5' };

export const ACTIVITY_DEFAULT_BRODER_COLOR = '#64748b';
export const ACTIVITY_DEFAULT_BACKGROUND_COLOR = '#ffffff';
export const ACTIVITY_DEFAULT_TEXT_COLOR = '#0f172a';
export const ACTIVITY_DEFAULT_HOVER_COLOR = '#e2e8f0';
export const GROUP_DEFAULT_BACKGROUND_COLOR = '#87e4fc';
export const GROUP_DEFAULT_BRODER_COLOR = '#38b6f5';
export const GROUP_DEFAULT_HOVER_COLOR = '#AFF2FE';
export const CUSTOM_TEXT_COLOR_CLASS = 'customTextColor';
export const CUSTOM_BACKGROUND_COLOR_CLASS = 'customBackgroundColor';

// ⚠️ The keys of this object are saved on the server, so changing them is strictly prohibited. ⚠️
// ⚠️ If changes are necessary, we must provide fallback for the altered keys. ⚠️
// ⚠️ The rest of the colors can be changed as needed. ⚠️
export const ACTIVITY_COLORS_MAP_CANVAS: {
  [color: string]: {
    borderColor: string; // Border color
    textColor: string; // Text color
    hoverColor: string; // Hover color for expand/collapse icons
    shadowColor: string; // Color for shadow activity/task
    progressColor: string; // Progress bar color
    progressBgColor: string; // Progress bar background color
    label: string; // Label of color
    editColor?: string; // Color of element in edit state
    checkboxColor: string; // Color fo checkbox on combo search boc
    checkboxFillColor: string; // Color fo checkbox (filled) on combo search boc
    checkboxTickColor?: string;
  };
} = {
  '#64748b': { borderColor: '#334155', textColor: '#ffffff', hoverColor: '#cbd5e1', shadowColor: '#ffffff', progressColor: '#1e293b', progressBgColor: '#e2e8f0', checkboxColor: '#ffffff', checkboxFillColor: '#ffffff', label: 'Dark Grey', checkboxTickColor: '#0f172a' },
  '#38b6f5': { borderColor: '#1c6bb0', textColor: '#0f172a', hoverColor: '#87e4fc', shadowColor: '#d7fbfe', progressColor: '#114c8e', progressBgColor: '#aff2fe', checkboxColor: '#ffffff', checkboxFillColor: '#ffffff', label: 'Dark Blue', checkboxTickColor: '#0f172a' },
  '#7437f4': { borderColor: '#411baf', textColor: '#ffffff', hoverColor: '#b486fb', shadowColor: '#e8d7fe', progressColor: '#2D118D', progressBgColor: '#D0AFFD', checkboxColor: '#ffffff', checkboxFillColor: '#ffffff', label: 'Dark Purple', checkboxTickColor: '#0f172a' },
  '#0d968b': { borderColor: '#06616c', textColor: '#ffffff', hoverColor: '#65dfbf', shadowColor: '#ccf9e5', progressColor: '#044757', progressBgColor: '#9BF4D5', checkboxColor: '#ffffff', checkboxFillColor: '#ffffff', label: 'Dark Green', checkboxTickColor: '#0f172a' },
  '#f43787': { borderColor: '#af1b77', textColor: '#ffffff', hoverColor: '#fb86a0', shadowColor: '#fed7d7', progressColor: '#8D116B', progressBgColor: '#FDAFB9', checkboxColor: '#ffffff', checkboxFillColor: '#ffffff', label: 'Dark Pink', checkboxTickColor: '#0f172a' },
  '#f46d37': { borderColor: '#af311b', textColor: '#ffffff', hoverColor: '#fbb886', shadowColor: '#feedd7', progressColor: '#8d1b11', progressBgColor: '#fdd5af', checkboxColor: '#ffffff', checkboxFillColor: '#ffffff', label: 'Dark Orange', checkboxTickColor: '#0f172a' },
  '#f2e735': { borderColor: '#aea31a', textColor: '#0f172a', hoverColor: '#fdfaae', shadowColor: '#fefdd6', progressColor: '#8C8210', progressBgColor: '#FEFDD6', checkboxColor: '#64748b', checkboxFillColor: '#ffffff', label: 'Dark Yellow', checkboxTickColor: '#0f172a' },
  '#cbd5e1': { borderColor: '#64748b', textColor: '#0f172a', hoverColor: '#e2e8f0', shadowColor: '#ffffff', progressColor: '#475569', progressBgColor: '#F1F5F9', checkboxColor: '#475569', checkboxFillColor: '#3761f4', label: 'Medium Grey' },
  '#87e4fc': { borderColor: '#38b6f5', textColor: '#0f172a', hoverColor: '#aff2fe', shadowColor: '#d7fbfe', progressColor: '#288FD2', progressBgColor: '#D7FBFE', checkboxColor: '#475569', checkboxFillColor: '#3761f4', label: 'Medium Blue' },
  '#b486fb': { borderColor: '#7437f4', textColor: '#0f172a', hoverColor: '#d0affd', shadowColor: '#e8d7fe', progressColor: '#5928D1', progressBgColor: '#E8D7FE', checkboxColor: '#475569', checkboxFillColor: '#3761f4', label: 'Medium Purple' },
  '#65dfbf': { borderColor: '#0d968b', textColor: '#0f172a', hoverColor: '#9bf4d5', shadowColor: '#ccf9e5', progressColor: '#097F81', progressBgColor: '#CCF9E5', checkboxColor: '#475569', checkboxFillColor: '#3761f4', label: 'Medium Green' },
  '#fb86a0': { borderColor: '#f43787', textColor: '#0f172a', hoverColor: '#fdafb9', shadowColor: '#fed7d7', progressColor: '#D12880', progressBgColor: '#FED7D7', checkboxColor: '#475569', checkboxFillColor: '#3761f4', label: 'Medium Pink' },
  '#fbb886': { borderColor: '#f46d37', textColor: '#0f172a', hoverColor: '#fdd5af', shadowColor: '#feedd7', progressColor: '#D14D28', progressBgColor: '#FEEDD7', checkboxColor: '#475569', checkboxFillColor: '#3761f4', label: 'Medium Orange' },
  '#fbf585': { borderColor: '#d0c526', textColor: '#0f172a', hoverColor: '#fefdd6', shadowColor: '#fefdd6', progressColor: '#AEA31A', progressBgColor: '#FEFDE7', checkboxColor: '#475569', checkboxFillColor: '#3761f4', label: 'Medium Yellow' },
  '#ffffff': { borderColor: '#64748b', textColor: '#0f172a', hoverColor: '#e2e8f0', shadowColor: '#ffffff', progressColor: '#64748B', progressBgColor: '#CBD5E1', checkboxColor: '#64748b', checkboxFillColor: '#3761f4', label: 'Light Grey', editColor: '#f1f5f9' },
  '#d7fbfe': { borderColor: '#38b6f5', textColor: '#0f172a', hoverColor: '#87e4fc', shadowColor: '#d7fbfe', progressColor: '#38B6F5', progressBgColor: '#87E4FC', checkboxColor: '#64748b', checkboxFillColor: '#3761f4', label: 'Light Blue' },
  '#e8d7fe': { borderColor: '#7437f4', textColor: '#0f172a', hoverColor: '#b486fb', shadowColor: '#e8d7fe', progressColor: '#7437F4', progressBgColor: '#B486FB', checkboxColor: '#64748b', checkboxFillColor: '#3761f4', label: 'Light Purple' },
  '#ccf9e5': { borderColor: '#0d968b', textColor: '#0f172a', hoverColor: '#65dfbf', shadowColor: '#ccf9e5', progressColor: '#0D968B', progressBgColor: '#65DFBF', checkboxColor: '#64748b', checkboxFillColor: '#3761f4', label: 'Light Green' },
  '#fed7d7': { borderColor: '#f43787', textColor: '#0f172a', hoverColor: '#fb86a0', shadowColor: '#fed7d7', progressColor: '#F43787', progressBgColor: '#FB86A0', checkboxColor: '#64748b', checkboxFillColor: '#3761f4', label: 'Light Pink' },
  '#feedd7': { borderColor: '#f46d37', textColor: '#0f172a', hoverColor: '#fbb886', shadowColor: '#feedd7', progressColor: '#F46D37', progressBgColor: '#FBB886', checkboxColor: '#64748b', checkboxFillColor: '#3761f4', label: 'Light Orange' },
  '#fefdd6': { borderColor: '#d0c526', textColor: '#0f172a', hoverColor: '#f7ef66', shadowColor: '#fefdd6', progressColor: '#D0C526', progressBgColor: '#F7EF66', checkboxColor: '#64748b', checkboxFillColor: '#3761f4', label: 'Light Yellow' }
};

// ⚠️ The keys of this object are saved on the server, so changing them is strictly prohibited. ⚠️
// ⚠️ If changes are necessary, we must provide fallback for the altered keys. ⚠️
// ⚠️ The rest of the colors can be changed as needed. ⚠️
export const ACTIVITY_COLORS_MAP_GANTT: {
  [color: string]: { activityColor: string; borderColor: string; progressColor: string; label: string };
} = {
  '#64748b': { activityColor: '#94a3b8', progressColor: '#334155', borderColor: '#334155', label: 'Dark Grey' },
  '#38b6f5': { activityColor: '#38b6f5', progressColor: '#1c6bb0', borderColor: '#1c6bb0', label: 'Dark Blue' },
  '#7437f4': { activityColor: '#9b68f8', progressColor: '#411baf', borderColor: '#411baf', label: 'Dark Purple' },
  '#0d968b': { activityColor: '#0d968b', progressColor: '#06616c', borderColor: '#06616c', label: 'Dark Green' },
  '#f43787': { activityColor: '#f43787', progressColor: '#af1b77', borderColor: '#af1b77', label: 'Dark Pink' },
  '#f46d37': { activityColor: '#f46d37', progressColor: '#af311b', borderColor: '#af311b', label: 'Dark Orange' },
  '#f2e735': { activityColor: '#f2e735', progressColor: '#aea31a', borderColor: '#aea31a', label: 'Dark Yellow' },
  '#cbd5e1': { activityColor: '#cbd5e1', progressColor: '#64748b', borderColor: '#64748b', label: 'Medium Grey' },
  '#87e4fc': { activityColor: '#87e4fc', progressColor: '#38b6f5', borderColor: '#38b6f5', label: 'Medium Blue' },
  '#b486fb': { activityColor: '#b486fb', progressColor: '#7437f4', borderColor: '#7437f4', label: 'Medium Purple' },
  '#65dfbf': { activityColor: '#65dfbf', progressColor: '#0d968b', borderColor: '#0d968b', label: 'Medium Green' },
  '#fb86a0': { activityColor: '#fb86a0', progressColor: '#f43787', borderColor: '#f43787', label: 'Medium Pink' },
  '#fbb886': { activityColor: '#fbb886', progressColor: '#f46d37', borderColor: '#f46d37', label: 'Medium Orange' },
  '#fbf585': { activityColor: '#fbf585', progressColor: '#d0c526', borderColor: '#f2e735', label: 'Medium Yellow' },
  '#ffffff': { activityColor: '#f1f5f9', progressColor: '#94a3b8', borderColor: '#94a3b8', label: 'Light Grey' },
  '#d7fbfe': { activityColor: '#d7fbfe', progressColor: '#68d2f9', borderColor: '#68d2f9', label: 'Light Blue' },
  '#e8d7fe': { activityColor: '#e8d7fe', progressColor: '#9b68f8', borderColor: '#9b68f8', label: 'Light Purple' },
  '#ccf9e5': { activityColor: '#ccf9e5', progressColor: '#3cc0a9', borderColor: '#3cc0a9', label: 'Light Green' },
  '#fed7d7': { activityColor: '#fed7d7', progressColor: '#f86896', borderColor: '#f86896', label: 'Light Pink' },
  '#feedd7': { activityColor: '#feedd7', progressColor: '#f89b68', borderColor: '#f89b68', label: 'Light Orange' },
  '#fefdd6': { activityColor: '#fefdd6', progressColor: '#f2e735', borderColor: '#f2e735', label: 'Light Yellow' }
};

// ⚠️ This object is used to show fallback colors for old projects having old colors settings. ⚠️
// ⚠️ Changing this object is strictly prohibited. ⚠️
export const FALLBACK_FOR_OLD_ELEMENTS_COLORS: {
  [oldColor: string]: { bgColor: string };
} = {
  '#64748b': { bgColor: '#ffffff' },
  '#38b6f5': { bgColor: '#87e4fc' },
  '#f46d37': { bgColor: '#fbb886' },
  '#7437f4': { bgColor: '#b486fb' },
  '#0d968b': { bgColor: '#65dfbf' },
  '#f43787': { bgColor: '#fb86a0' }
};

// ⚠️ This object is used to show fallback colors for old projects having old colors settings. ⚠️
// ⚠️ Changing this object is strictly prohibited. ⚠️
export const FALLBACK_FOR_OLD_GROUP_COLORS: {
  [oldColor: string]: { bgColor: string };
} = {
  '#d7fbfe': { bgColor: '#87e4fc' },
  '#feedd7': { bgColor: '#fbb886' },
  '#e8d7fe': { bgColor: '#b486fb' },
  '#ccf9e5': { bgColor: '#65dfbf' },
  '#fed7d7': { bgColor: '#fb86a0' }
};

export const ORGANIZATION_CODE_BORDER_COLORS_MAP: { [color: string]: string } = {
  '#ffffff': '#64748b',
  '#fdf2af': '#f4cb37',
  '#afc6fd': '#3761f4',
  '#94f7aa': '#00b85f',
  '#fdc3af': '#f43737',
  '#aff2fe': '#38b6f5',
  '#fdafb9': '#f43787',
  '#d0affd': '#7437f4',
  '#fdd5af': '#f46d37',
  '#f7affd': '#bf37f4',
  '#9bf4d5': '#0d968b'
};

export const CUSTOM_COLOR_ELEMENT_PROPERTIES = {
  COLOR: 'COLOR' as const,
  WBS_BAR_COLOR: 'WBS_BAR_COLOR' as const,
  WBS_BAR_BORDER_COLOR: 'WBS_BAR_BORDER_COLOR' as const,
  WBS_HOVER_COLOR: 'WBS_HOVER_COLOR' as const,
  ACTIVITY_COLOR: 'ACTIVITY_COLOR' as const,
  PROGRESS_COLOR: 'PROGRESS_COLOR' as const,
  GRID_ICON_HOVER_COLOR: 'GRID_ICON_HOVER_COLOR' as const,
  GRID_ICON_COLOR: 'GRID_ICON_COLOR' as const
};

export const CUSTOM_COLOR_CSS_PROPERTIES = {
  BACKGROUND_COLOR: 'background-color',
  BORDER: 'border',
  OUTLINE: 'outline',
  BORDER_BOTTOM: 'border-bottom',
  BORDER_COLOR: 'border-color',
  TEXT_COLOR: 'color'
};

export const VARIANCE_REASONS_COLORS_MAP_FOR_DASHBOARD: { [color: string]: string } = {
  '#afc6fd': '#3761F4',
  '#aff2fe': '#38B6F5',
  '#e5faac': '#95D62F',
  '#fdafb9': '#F43787',
  '#fdf2af': '#F4CB37',
  '#d0affd': '#7437F4',
  '#fdd5af': '#F46D37',
  '#f7affd': '#BF37F4',
  '#9bf4d5': '#0D968B'
};

export const TABLE_DEPTH_EFFECT_WIDTH = 4; // keep it in sync with css variable --tableDepthEffectWidth, removing the use of getCSSVariable as it seems a performance overhead
export const GANTT_TABLE_DEPTH_EFFECT_HEIGHT = 3;
export const TIMESPAN_GRID_COLUMN_MIN_WIDTH = 150;
export const TIMESPAN_GRID_DATE_MIN_WIDTH = 250;
export const TIMESPAN_GRID_DURATION_MIN_WIDTH = 60;
export const TABLE_RESOURCE_PILL_WIDTH = 86;

export const COMMENT_REACTION_TYPE = {
  COMMENT: 'comment',
  REPLY: 'reply',
  RESOLVED: 'resolved'
};

export const NEW_CUSTOM_CODE_COLOR_MAP: { [key: string]: string } = {
  '#dab0fb': '#5928d1',
  '#d5edb0': '#77b822',
  '#b0c9fb': '#2849d1',
  '#faecb4': '#d1a928',
  '#b4dab2': '#097f81',
  '#f7b0db': '#9628d1',
  '#fbd3b0': '#d14d28',
  '#bae4fc': '#288fd2',
  '#bbb0fb': '#5928d1',
  '#f7afb0': '#d12880'
};

export const SECONDARY_CUSTOM_CODE_COLOR_MAP: {
  [color: string]: { activityColor: string; borderColor: string; progressColor: string };
} = {
  '#dab0fb': { activityColor: '#F7AFFD', borderColor: '#D968F8', progressColor: '#D968F8' },
  '#d5edb0': { activityColor: '#E5FAAC', borderColor: '#B7E65F', progressColor: '#B7E65F' },
  '#b0c9fb': { activityColor: '#AFC6FD', borderColor: '#688BF8', progressColor: '#688BF8' },
  '#faecb4': { activityColor: '#FDF2AF', borderColor: '#F8DC68', progressColor: '#F8DC68' },
  '#b4dab2': { activityColor: '#9BF4D5', borderColor: '#3CC0A9', progressColor: '#3CC0A9' },
  '#f7b0db': { activityColor: '#FDAFB9', borderColor: '#F86896', progressColor: '#F86896' },
  '#fbd3b0': { activityColor: '#FDD5AF', borderColor: '#F89B68', progressColor: '#F89B68' },
  '#bae4fc': { activityColor: '#AFF2FE', borderColor: '#68D2F9', progressColor: '#68D2F9' },
  '#bbb0fb': { activityColor: '#D0AFFD', borderColor: '#9B68F8', progressColor: '#9B68F8' },
  '#f7afb0': { activityColor: '#FDC3AF', borderColor: '#F87468', progressColor: '#F87468' }
};

export const OPTION_COLOR_MAP: {
  [color: string]: { activityColor: string; borderColor: string; progressColor: string };
} = {
  '#dab0fb': { activityColor: '#F7AFFD', borderColor: '#D968F8', progressColor: '#D968F8' },
  '#d5edb0': { activityColor: '#E5FAAC', borderColor: '#B7E65F', progressColor: '#B7E65F' },
  '#b0c9fb': { activityColor: '#AFC6FD', borderColor: '#688BF8', progressColor: '#688BF8' },
  '#faecb4': { activityColor: '#FDF2AF', borderColor: '#F8DC68', progressColor: '#F8DC68' },
  '#b4dab2': { activityColor: '#9BF4D5', borderColor: '#3CC0A9', progressColor: '#3CC0A9' },
  '#f7b0db': { activityColor: '#FDAFB9', borderColor: '#F86896', progressColor: '#F86896' },
  '#fbd3b0': { activityColor: '#FDD5AF', borderColor: '#F89B68', progressColor: '#F89B68' },
  '#bae4fc': { activityColor: '#AFF2FE', borderColor: '#68D2F9', progressColor: '#68D2F9' },
  '#bbb0fb': { activityColor: '#D0AFFD', borderColor: '#9B68F8', progressColor: '#9B68F8' },
  '#f7afb0': { activityColor: '#FDC3AF', borderColor: '#F87468', progressColor: '#F87468' }
};

export const NAME_LIMITS = {
  PROJECT_NAME: 90,
  PROJECT_SHORT_NAME: 20,
  CALENDAR_NAME: 255,
  ACTIVITY_NAME: 120,
  TASK_NAME: 120,
  GROUP_NAME: 100,
  INTERIM_MILESTONE_NAME: 120,
  START_MILESTONE_NAME: 120,
  END_MILESTONE_NAME: 120,
  ID_NAME: 40,
  /** Reserved characters for parent activity ID prefix (e.g., ACT-1_) when editing child IDs */
  PARENT_ID_NAME: 6,
  CODE_VALUE_NAME: 60,
  CODE_NAME: 40,
  ORGANIZATION_FIELD_NAME: 60,
  ORGANIZATION_FIELD_OPTION_NAME: 60
};

export const IS_IPAD = navigator.platform.toUpperCase().indexOf('IPAD') >= 0 || (navigator.platform.toUpperCase().indexOf('MAC') >= 0 && navigator.maxTouchPoints > 1);
export const LOADING_CANVAS_MESSAGE = 'Loading Canvas';
export const LOADING_TABLE_MESSAGE = 'Loading Table';
export const LOADING_GANTT_MESSAGE = 'Loading Gantt';
